import { Routes } from '@angular/router';
import { MonosyllabicKeyboardFreeformPage } from './monosyllabic-keyboard-freeform-page/monosyllabic-keyboard-freeform-page';
import { MonosyllabicKeyboardPage } from './monosyllabic-keyboard-page/monosyllabic-keyboard-page';
import { SyllabicKeyboardPage } from './syllabic-keyboard-page';

export const mechanicSyllabicKeyboardRoutes: Routes = [
  {
    path: '',
    component: SyllabicKeyboardPage,
  },
  {
    path: 'monosyllabic',
    component: MonosyllabicKeyboardPage,
  },
  {
    path: 'monosyllabic-freeform',
    component: MonosyllabicKeyboardFreeformPage,
  },
];
